import React, { useLayoutEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useAsyncValue, useNavigate } from 'react-router-dom';

// Components
import WorkEquipmentForm from '../../../../../components/forms/ActionForms/WorkEquipmentForm';

// Types
import { WorkEquipmentFormValues } from '../../../../../components/forms/ActionForms/WorkEquipmentForm/types';
import { roidOTSelected } from '../../../../../state/actions/ui/roidOTSelectedGeneralView';
import { OrderType } from '../../../../../types/orders';

// Constants
import { formActionNaming } from '../../../../../components/forms/ActionForms/constants';

export default function WorkEquipmentFormPage(): JSX.Element {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loaderData = useAsyncValue() as WorkEquipmentFormValues;

  useLayoutEffect(() => {
    dispatch(
      roidOTSelected(
        OrderType.Action,
        loaderData.breadCrumbsData.orderParentRoid,
        loaderData.breadCrumbsData.orderParentId
      )
    );
  }, []);

  const onFormSubmit = () => {
    navigate('../animals');
  };

  return (
    <WorkEquipmentForm
      onFormSubmit={onFormSubmit}
      initialData={loaderData}
      sessionStorageKey={formActionNaming.NEW_WORK_EQUIPMENT_FORM}
    />
  );
}
